import { render, staticRenderFns } from "./Freelancing.vue?vue&type=template&id=0d008e03&"
import script from "./Freelancing.vue?vue&type=script&lang=js&"
export * from "./Freelancing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports